import RedisConnectionPool from "../../util/ConnectionPool";
import Cache from "./Cache";

export default class RedisRepository implements Cache {
  async del(key: string): Promise<void> {
    if (process.env.REDISCLOUD_URL) {
      const conn = await RedisConnectionPool.GetConnection();
      await conn.DEL(key);
      RedisConnectionPool.releaseConnection(conn);
    }
  }

  async get(key: string): Promise<any> {
    if (process.env.REDISCLOUD_URL) {
      const conn = await RedisConnectionPool.GetConnection();
      try {
        const data = await conn.get(key);

        if (!data) throw new Error();

        return JSON.parse(data);
      } catch (e) {
        return await conn.GET(key);
      } finally {
        RedisConnectionPool.releaseConnection(conn);
      }
    }
  }

  async set(key: string, obj: any, ttl?: number): Promise<void> {
    if (process.env.REDISCLOUD_URL) {
      const conn = await RedisConnectionPool.GetConnection();
      if (obj) {
        await conn.SETEX(key, !ttl ? 86400 : ttl, JSON.stringify(obj));
      }
      RedisConnectionPool.releaseConnection(conn);
    }
  }

  async delPattern(pattern: string): Promise<void> {
    if (process.env.REDISCLOUD_URL) {
      const conn = await RedisConnectionPool.GetConnection();
      await conn.EVAL(
        "for _,k in ipairs(redis.call('keys','" +
          pattern +
          "')) do redis.call('del',k) end"
      );
      RedisConnectionPool.releaseConnection(conn);
    }
  }

  async getByPattern(pattern: string): Promise<any[]> {
    if (process.env.REDISCLOUD_URL) {
      let cursor: number = 0;
      const keys = [];
      const conn = await RedisConnectionPool.GetConnection();
      do {
        const reply = await conn.scan(cursor, {
          MATCH: pattern,
          COUNT: 100,
        });
        cursor = reply.cursor;
        keys.push(...reply.keys);
      } while (cursor !== 0);

      const values = [];

      for (const key of keys) {
        const value = await conn.get(key);
        values.push(value);
      }

      RedisConnectionPool.releaseConnection(conn);
      return values;
    }

    return [];
  }
}
